import { TABLET_SCREEN_SIZE, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import { PageStatus } from '@brandclub/types';
import React from 'react';
import { styled, Grid } from '@mui/material';
import PageCard from '../components/PageCard/index.js';
import pluralize from 'pluralize';

var Container = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return ({
        boxSizing: 'border-box',
        fontFamily: 'Poppins',
        color: theme.palette.primary.main,
        padding: "30px 5%",
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: '50vh',
        '.container-grid': (_b = {
                maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
                width: '100%',
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                gap: '40px'
            },
            _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                backgroundColor: '#fff',
                gridTemplateColumns: '1fr 1fr',
                gap: '20px',
            },
            _b["@media (max-width: 600px)"] = {
                justifyContent: 'center',
                gridTemplateColumns: '1fr',
            },
            _b),
        '.no-data-container': {
            minHeight: '50vh',
            h1: {
                fontColor: theme.palette.primary.main,
                fontFamily: 'Poppins',
            },
        },
    });
});
var BrandclubPageCards = function (_a) {
    var LinkComponent = _a.LinkComponent, persistentQueryParams = _a.persistentQueryParams, site = _a.site, page = _a.page, brandEntity = _a.brandEntity, routePrefix = _a.routePrefix;
    var landingPage = site.pages.find(function (p) { return p.pageType === page.pageType; });
    var targetPages = ((landingPage === null || landingPage === void 0 ? void 0 : landingPage.childPages) || []).filter(function (p) { return p.status === PageStatus.Visible; });
    var placeholderImage = 'https://media.brandclub.com/cms/widgets/Placeholder_Green_Image_10x7.png';
    return (React.createElement(Container, null,
        React.createElement(Grid, { className: "container-grid" }, targetPages && targetPages.length > 0 ? (targetPages.map(function (targetPage) {
            return (React.createElement(Grid, { key: targetPage.title, item: true, xs: 12, sm: 6, md: 4 },
                React.createElement(PageCard, { LinkComponent: LinkComponent, persistentQueryParams: persistentQueryParams, brandEntity: brandEntity, pageType: targetPage.pageType, route: targetPage.route, createdTime: targetPage.createdTime, displayName: targetPage.displayName, previewImageUrl: targetPage.previewImageUrl || placeholderImage, routePrefix: routePrefix })));
        })) : (React.createElement("div", { className: "no-data-container" },
            React.createElement("h1", null,
                "No ",
                pluralize(page.pageType.toLowerCase())))))));
};

export { BrandclubPageCards };
//# sourceMappingURL=index.js.map
